import EmailContentEditor from "./EmailContentEditor";

export default EmailContentEditor;
